module.exports = __webpack_public_path__ + "media/universities/Ecole_Polytechnique-adc68f64.png";